<google-map
    [height]="'300px'"
    [width]="'100%'"
    [center]="center"
    [zoom]="zoom">
    <map-marker
        *ngFor="let marker of markers"
        [position]="marker.position"
        [label]="marker.label"
        [title]="marker.title">
    </map-marker>
</google-map>
